<h1 class="landing">
  <img src="assets/logo2.png">
  Quel(le) partenaire es-tu pour ta Flamme ?
</h1>
<div class="description">
  Avant de commencer, dépose tes certitudes et tes jugements à la porte. Imagine que ta joie, tes rêves et tes désirs
  profonds forment une personne à part entière. Une compagne de vie qui partage ton toit, tes jours et tes nuits.
  <br/>
  <br/>
  Ce quiz est un tête-à-tête avec elle. Il n’est pas là pour te juger ou te donner des leçons, mais pour t’inviter à une
  première danse, un premier pas vers ton cœur.
</div>
<div class="notabene">
  À noter : Ce quiz a été imaginé avec tout mon amour. Il n'a aucune valeur scientifique, mais il possède une immense valeur de cœur. ✨
</div>
<app-accent title="Mon petit conseil">
  Ne cherche pas la "bonne" réponse ou une preuve logique. Laisse ton mental de côté et réponds avec ton instinct. La
  première réponse qui vibre est souvent celle que ton cœur essaie de te dire. Plus tu joueras le jeu de la sincérité,
  plus tu découvriras la couleur actuelle de votre relation.
</app-accent>
<div class="flex flex-column justify-content-center align-items-center gap-4 p-4">

  <p-button label="Démarrer" icon="pi pi-play" (onClick)="startQuiz()"></p-button>
</div>
